import { render } from "./ProductPackage.vue?vue&type=template&id=11e3e57b&scoped=true"
import script from "./ProductPackage.vue?vue&type=script&lang=js"
export * from "./ProductPackage.vue?vue&type=script&lang=js"

import "./ProductPackage.vue?vue&type=style&index=0&id=11e3e57b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e3e57b"]])

export default __exports__